export default __webpack_public_path__ + "static/media/Junge-auf-Trampolin.27618c2b.webp";